export enum HeadquarterCode {
  AsiaPacific = '501',
  Europe = '502',
  LatinAmerica = '503',
  MiddleEastAndAfrica = '504',
  NorthAmerica = '505',
}
